import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index55.css';const section = "_section_1sjmi_1";
const withoutPadding = "_withoutPadding_1sjmi_9";
const s = {
  section,
  withoutPadding
};
const Section = withThemeAndSize(
  forwardRef(({ className, withoutPadding: withoutPadding2, ...rest }, ref) => /* @__PURE__ */ jsx("section", { ...rest, className: clsx(s.section, { [s.withoutPadding]: withoutPadding2 }, className), ref }))
);
Section.displayName = "Modal.Section";
export {
  Section
};
